/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  Modal,
  Form,
  Input,
} from 'antd';
import {
  ArrowLeftOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import FormSubmitControls from 'components/FormSubmitCustomControls';

const ModalReabrir = ({
  visible,
  setVisible,
  callback,
}) => {
  const [form] = Form.useForm();

  const onFinish = async () => {
    await form.validateFields();
    const values = form.getFieldsValue();
    callback(values);
    setVisible(false);
    form.resetFields();
  };
  const onCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const saveControl = {
    text: 'Guardar',
    icon: <SaveOutlined />,
    onClick: () => onFinish(),
  };

  const backControl = {
    text: 'Regresar',
    icon: <ArrowLeftOutlined />,
    onClick: () => onCancel(),
  };

  const getControls = () => [backControl, saveControl];

  return (
    <Modal
      footer={null}
      closable={false}
      visible={visible}
      title={(
        <Row justify="space-between">
          <span>
            Motivo de Reapertura
          </span>
          <FormSubmitControls
            controls={getControls()}
          />
        </Row>
        )}
    >
      <Row>
        <Col span={24}>
          <Form
            form={form}
            layout="vertical"
            initialValues={{ estados_globales: 1 }}
            name="motivo"
          >
            <Col span={24}>
              <Form.Item
                name="motivo_de_reapertura"
                label="Motivo de Reapertura"
                hasFeedback
                rules={[{ required: true }]}
              >
                <Input.TextArea autoSize={{ minRows: 3, maxRows: 3 }} allowClear />
              </Form.Item>
            </Col>
          </Form>
        </Col>
      </Row>
    </Modal>
  );
};

ModalReabrir.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  callback: PropTypes.func,
};
ModalReabrir.defaultProps = {
  callback: {},
};

export default ModalReabrir;
